module.exports = __webpack_public_path__ + "static/media/about_pc_2.bcf187af.png";